import { Spin } from "antd";
const DefaultLoader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Spin size="large" tip="Loading..." />
    </div>
  );
};

export default DefaultLoader;
